export default {
  title: 'Bestelldetails',
  order_again: 'Erneut bestellen',
};
